module.exports = __webpack_public_path__ + "static/media/creator-ycss.8909efba.png";